export default [
  'user',
  'org',
  'orgMultiple',
  'area',
  'standard',
  'userMultiple',
  'ref',
  'sysref',
]